import { api, setCsrfToken } from "./api";
import type { CurrentUser } from "./types";

const SSO_ORIGIN = "https://sso.works.io.vn";

export function startWorksSso(): void {
  const state = crypto.randomUUID();
  const nonce = crypto.randomUUID();
  sessionStorage.setItem("works_sso_state", state);
  sessionStorage.setItem("works_sso_nonce", nonce);
  const authorize = new URL(`${SSO_ORIGIN}/authorize`);
  authorize.searchParams.set("client_id", "bom");
  authorize.searchParams.set(
    "redirect_uri",
    `${location.origin}${location.pathname}`,
  );
  authorize.searchParams.set("state", state);
  authorize.searchParams.set("nonce", nonce);
  authorize.searchParams.set("response_type", "token");
  authorize.searchParams.set("response_mode", "fragment");
  location.assign(authorize.toString());
}

export async function completeWorksSsoCallback(): Promise<CurrentUser | null> {
  const hash = new URLSearchParams(location.hash.slice(1));
  const token = hash.get("access_token");
  if (!token) return null;
  const state = hash.get("state");
  const expectedState = sessionStorage.getItem("works_sso_state");
  const nonce = sessionStorage.getItem("works_sso_nonce");
  sessionStorage.removeItem("works_sso_state");
  sessionStorage.removeItem("works_sso_nonce");
  history.replaceState(null, "", `${location.pathname}${location.search}`);
  if (!state || state !== expectedState || !nonce)
    throw new Error("SSO callback không hợp lệ.");
  const result = await api<{ user: CurrentUser; csrfToken: string }>(
    "/auth/sso",
    { method: "POST", body: JSON.stringify({ token, nonce }) },
  );
  setCsrfToken(result.csrfToken);
  return { ...result.user, csrfToken: result.csrfToken };
}
